import { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  useLocation,
} from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { ToastContainer } from "react-toastify";
import { useSelector } from 'react-redux';
import "react-toastify/dist/ReactToastify.css";
import { Loading, Navbar } from "./components";
import { selectCommonData } from "./reducers/common.reducer";
import ModernSidebar from "./components/SidebarV2";
import AppRoutes from './routes';
import CustomSpeedDial from './components/SpeedDial';
import PageBreadcrumb from './components/PageBreadcrumb';
import { useWindowWidth } from '@react-hook/window-size';


function MainContent() {
  const onlyWidth = useWindowWidth();
  const { isLoading } = useSelector(selectCommonData);
  const location = useLocation();
  const [showSideBar, setShowSideBar] = useState(false);
  const [darkMode, setDarkMode] = useState(
    () => sessionStorage.getItem("smartReportTheme") === "dark"
  );

  useEffect(() => {
    AOS.init();
  }, []);

     useEffect(() => {
      if (darkMode) {
        document.documentElement.classList.add("dark"); 
      } else {
        document.documentElement.classList.remove("dark");
      }
      sessionStorage.setItem("smartReportTheme", darkMode ? "dark" : "light");
    }, [darkMode]);

   const showLayout = location.pathname !== "/login";

  return (
    <div className="h-screen overflow-hidden">
      {isLoading && <Loading />}
      {/* {location.pathname !== "/login" && (
        // <Sidebar open={showSideBar} setOpen={setShowSideBar} />
        <ModernSidebar open={showSideBar} setOpen={setShowSideBar}/>
      )} */}
      <div className="flex h-full">
         {showLayout && (
          <ModernSidebar open={showSideBar} setOpen={setShowSideBar} darkMode={darkMode}/>
        )}
        <div className={`flex-1 flex flex-col overflow-auto ${showLayout ? 'pb-[40px]' : 'pb-0'} md:pb-0`}>
          {showLayout && <Navbar setShowSideBar={setShowSideBar} onlyWidth={onlyWidth} setDarkMode={setDarkMode} darkMode={darkMode}/>}
          <div className="overflow-y-auto dark:bg-custom_dark_background bg-customLightMilkWhite h-screen">
            {showLayout && <PageBreadcrumb />}
            <AppRoutes />
          </div>
          {showLayout &&  onlyWidth < 768 && <CustomSpeedDial />}
          <ToastContainer
            position="bottom-left"
            autoClose={1000}
            hideProgressBar={true}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <MainContent />
    </Router>
  );
}

export default App;
